import { FC } from 'react';
import { Checkbox } from 'antd';
import styles from './index.module.scss'

type CheckBoxFieldProps = {
	text: string | JSX.Element;
	value?: boolean;
	onChange?: ((e: any) => void) | undefined;
	id?: string;
};

export const CheckBoxField: FC<CheckBoxFieldProps> = ({ text, id, value, onChange }) => {
	return (
		<Checkbox
			name={id}
			className={styles.root}
			style={{ fontSize: '16px', lineHeight: '20px' }}
			checked={value}
			onChange={(v) => {
				if (onChange) {
					onChange(v.target.checked);
				}
			}}
		>
			{text}
		</Checkbox>
	);
};
